<template>
  <section class="signup-root">
    <error-modal
      :msg="errorMsg"
      @closeModal="closeErrorModal"
      v-if="errorFlag"
    ></error-modal>
    <transition name="fade">
      <section class="mask" v-if="showCodeImg">
        <section class="pop-modal">
          <div class="modal-head">
            <div class="modal-tit">
              <span class="tit-border"></span>
              {{ $t("signup.pleaseInsertCode") }}
              <svg
                @click="closeModal"
                class="close-icon"
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <path
                    d="M18.3192564,1.6807436 L10,10 L18.3192564,18.3192564 L10,10 L1.6807436,18.3192564 L10,10 L1.6807436,1.6807436 L10,10 L18.3192564,1.6807436 Z M10,7.6230696 L17.1307912,0.492278404 C17.7871624,-0.164092801 18.8513504,-0.164092801 19.5077216,0.492278404 C20.1640928,1.14864961 20.1640928,2.2128376 19.5077216,2.8692088 L12.3769304,10 L19.5077216,17.1307912 C20.1640928,17.7871624 20.1640928,18.8513504 19.5077216,19.5077216 C18.8513504,20.1640928 17.7871624,20.1640928 17.1307912,19.5077216 L10,12.3769304 L2.8692088,19.5077216 C2.2128376,20.1640928 1.14864961,20.1640928 0.492278404,19.5077216 C-0.164092801,18.8513504 -0.164092801,17.7871624 0.492278404,17.1307912 L7.6230696,10 L0.492278404,2.8692088 C-0.164092801,2.2128376 -0.164092801,1.14864961 0.492278404,0.492278404 C1.14864961,-0.164092801 2.2128376,-0.164092801 2.8692088,0.492278404 L10,7.6230696 Z"
                    id="path-1"
                  />
                </defs>
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1" />
                  </mask>
                  <use
                    id="Combined-Shape"
                    fill="#979797"
                    fill-rule="nonzero"
                    xlink:href="#path-1"
                  />
                  <g id="colour/#CCCCCC" mask="url(#mask-2)" fill="#CCCCCC">
                    <rect id="colour" x="0" y="0" width="20" height="20" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="modal-form">
            <k-input
              v-if="signUpWay === 'phone'"
              :placeholder="$t('signup.pleaseInsertGraph')"
              v-model="ruleForm.imgCode"
            >
              <span class="code-tip modal-code" @click="getCode">
                <img :src="codeImg" v-if="showCodeImg" />
              </span>
            </k-input>
            <k-input
              v-if="signUpWay === 'email'"
              :placeholder="$t('signup.pleaseInsertGraph')"
              v-model="emailCaptcha"
            >
              <span class="code-tip modal-code" @click="getCode1">
                <img :src="codeImg1" v-if="showCodeImg" />
              </span>
            </k-input>
            <div class="login-box-bot">
              <div class="login-btn allowed" @click="sendSms">
                {{ $t("signup.confirm") }}
              </div>
            </div>
          </div>
        </section>
      </section>
    </transition>
    <main class="contact-container">
      <section class="login-box" :class="{ jp: $region === 'jp' }">
        <div class="login-tit">{{ $t("signup.createAccount") }}</div>
        <div class="k-form" ref="signUpForm">
          <k-input
            class="phone-input"
            ref="phone"
            :placeholder="$t('signup.insertPhone')"
            :validOptions="rules.phone"
            v-model="ruleForm.phone"
            :label="$t('signup.phoneLabel')"
            v-if="signUpWay === 'phone'"
          >
            <k-select
              :selected="selected"
              :options="codeList"
              @selectedOption="selectOption"
              class="code-area"
            ></k-select>
          </k-input>
          <k-input
            ref="email"
            :placeholder="$t('signup.insertEmail')"
            :validOptions="rules.email"
            v-model="ruleForm.email"
            :label="$t('signup.emailLabel')"
            v-if="signUpWay === 'email'"
          ></k-input>

          <k-input
            :placeholder="$t('signup.pleaseInsertCode')"
            :validOptions="rules.code"
            v-model="ruleForm.code"
            :label="$t('signup.codeLabel')"
            ref="code"
          >
            <span
              class="code-tip"
              :class="{ off: !resend, jp: signUpWay === 'email' }"
              @click="getCode"
              ga-data="901001"
              >{{ txt.getCode }}</span
            >
          </k-input>

          <k-input
            :placeholder="$t('signup.insertNickNameSample')"
            :validOptions="rules.name"
            v-model="ruleForm.name"
            :label="$t('signup.nickNameLabel')"
            v-if="signUpWay === 'phone'"
          ></k-input>

          <k-input
            type="password"
            :placeholder="$t('signup.insertString')"
            :validOptions="rules.password"
            v-model="ruleForm.password"
            :label="$t('signup.passwordLabel')"
          ></k-input>

          <k-input
            class="confirm-pwd"
            :class="{ jp: signUpWay === 'email' }"
            type="password"
            :placeholder="$t('signup.reInsertString')"
            :validOptions="rules.v_password"
            v-model="ruleForm.v_password"
            :label="$t('signup.repasswordLabel')"
          ></k-input>
        </div>

        <div class="tip-line">
          <span
            class="radio-box"
            :class="{ checked: radioChecked }"
            @click="checkRadio"
          ></span>
          <span v-if="$region !== 'jp'">{{ $t("signup.readAndAgree") }}</span>
          <a
            v-if="$region === 'jp'"
            :href="`${$siteConfig.domain}/terms`"
            class="tip-link jp-link"
            @click="goPrivacy"
            >{{ $t("signup.userPolicy") }}</a
          >
          <span v-if="$region === 'jp'">{{ $t("signup.and") }}</span>
          <a
            v-if="$region === 'jp'"
            :href="`${$siteConfig.domain}/privacy_policy`"
            class="tip-link jp-link"
            @click="goPrivacy"
            >{{ $t("signup.privPolicy") }}</a
          >
          <a
            v-if="$region === 'komoe'"
            :href="`${$siteConfig.domain}/terms`"
            class="tip-link"
            @click="goPrivacy"
            ga-data="901003"
            >{{ $t("signup.policyName") }}</a
          >
          <span v-if="$region === 'jp'">{{
            $t("signup.readAndAgreeEnd")
          }}</span>
        </div>
        <div class="login-box-bot">
          <div
            class="login-btn"
            :class="{ allowed: submitReady }"
            @click="signUp"
            ga-data="901003"
          >
            {{ $t("signup.confirmSignup") }}
          </div>
          <div class="tip-line">
            {{ $t("signup.hadAccount") }}
            <span class="tip-link normal-underline" @click="goLogin">{{
              $t("signup.login")
            }}</span>
            <span v-if="$region === 'jp'">{{
              $t("signup.hadAccountEnd")
            }}</span>
          </div>
        </div>
      </section>
    </main>
    <transition name="fade" v-if="showModal">
      <section class="success-mask">
        <section class="success-pop-modal">
          <img src="./img/succeed.png" alt="success" class="success-pic" />
          <div class="success-line">
            <svg
              class="success-icon"
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle id="point" fill="#8FD7C1" cx="10" cy="10" r="10" />
                <path
                  d="M9.73024786,13.6739041 C9.28330787,14.1086986 8.55867498,14.1086986 8.111735,13.6739041 L4.33520499,10 C3.888265,9.56520546 3.888265,8.86026422 4.33520499,8.42546967 C4.78214497,7.99067513 5.50677786,7.99067513 5.95371785,8.42546967 L8.92099143,11.3121086 L14.0462822,6.32609591 C14.4932221,5.89130136 15.217855,5.89130136 15.664795,6.32609591 C16.111735,6.76089045 16.111735,7.46583169 15.664795,7.90062623 L9.73024786,13.6739041 Z"
                  id="right"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
            <span>{{ $t("signup.signupSuccess") }}</span>
          </div>
          <div class="success-tip">
            {{ counter }}{{ $t("signup.refirectWord1") }}
            <span class="success-link" @click="goPrev">{{
              $t("signup.refirectWord2")
            }}</span>
          </div>
        </section>
      </section>
    </transition>
  </section>
</template>

<script>
import utils from "@/utils";
const { getParams } = utils;
import JSEncrypt from "jsencrypt";

import kSelect from "@/component/select/select.vue";
import ErrorModal from "@/component/modal/error.vue";
import KInput from "@/component/input/input.vue";

export default {
  name: "signup",
  components: {
    kSelect,
    ErrorModal,
    KInput,
  },
  data() {
    var vm = this;
    var validEmail = (value, callback) => {
      const emailPattern = /\w[-\w.+]*@([-A-Za-z0-9]+\.)+([A-Za-z0-9][-A-Za-z0-9]+\.)?[A-Za-z]{2,14}$/;
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("signup.insertEmail")));
      } else {
        if (!emailPattern.test(value)) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.insertCorrectEmail")));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    var validPhone = (value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("signup.insertPhone")));
      } else {
        if (!value.match("^[0-9]{5,12}$")) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.insertCorrectPhone")));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    var validName = (value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("signup.insertNickName")));
      } else {
        if (value.length < 3 || value.length > 10) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.correctNickName")));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    var validFirstPassword = (value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("signup.insertPassword")));
      } else {
        if (value.length < 6 || value.length > 16) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.correctPassword")));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    var validPassword = (value, callback) => {
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("signup.pleaseRepasswordLabel")));
      } else {
        if (value.length < 6 || value.length > 16) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.correctPassword")));
        } else if (value !== this.ruleForm.password) {
          this.submitReady = false;
          return callback(new Error(vm.$t("signup.differentPassword")));
        } else {
          return callback(new Error("valid"));
        }
      }
    };
    return {
      validEmail,
      validPhone,
      validName,
      validFirstPassword,
      validPassword,
      showModal: false,
      errorFlag: false,
      txt: {
        getCode: this.$t("signup.getCode"),
      },
      selected: {
        id: "",
        val: "",
      },
      codeList: [],
      showCodeImg: false,
      codeImg: "",
      codeImg1: "",
      emailCaptcha: "",
      signUpWay: this.$region === "jp" ? "email" : "phone",
      ruleForm: {
        phone: "",
        email: "",
        name: "",
        imgCode: "",
        code: "",
        password: "",
        v_password: "",
      },
      rules: {
        phone: [{ validator: validPhone, trigger: "blur" }],
        email: [{ validator: validEmail, trigger: "blur" }],
        code: [
          {
            required: true,
            message: this.$t("signup.pleaseInsertCode"),
            trigger: "blur",
          },
        ],
        name: [{ validator: validName, trigger: "blur" }],
        password: [{ validator: validFirstPassword, trigger: "blur" }],
        v_password: [{ validator: validPassword, trigger: "blur" }],
      },
      radioChecked: false,
      submitReady: false,
      minute: 60,
      counter: 5,
      resend: true,
      lineIndex: 1,
    };
  },
  created() {
    if (this.signUpWay === "phone") {
      this.getCodeList();
    }
  },
  methods: {
    checkValue(value, validator) {
      const cb = (info) => {
        return info + "";
      };
      return validator(value, cb) === "Error: valid" ? true : false;
    },
    checkRadio() {
      this.radioChecked = !this.radioChecked;
      this.checkAllInputs();
    },
    // 獲取圖形驗證碼
    getCode1(tag) {
      if (tag === "switch") {
        if (this.lineIndex < 20) {
          ++this.lineIndex;
        } else {
          return;
        }
      }

      if (this.signUpWay === "email") {
        // 邮箱
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else if (this.signUpWay === "phone") {
        // 手机号
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else {
        // 邮箱和手机号码
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomainGlobal}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      }
    },
    getCode() {
      if (this.signUpWay === "email") {
        if (this.checkValue(this.ruleForm.email, this.validEmail)) {
          // this.sendSms();
          this.getCode1();
          this.showCodeImg = true;
        } else {
          this.$refs.email.validate();
        }
        return false;
      }
      this.$refs.phone.validate();
      if ((this.ruleForm.phone + "").match("^[0-9]{5,12}$")) {
        this.codeImg = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
        ++this.lineIndex;
        // this.codeImg =
        //   this.$siteConfig.captchaImgDomain +
        //   "/captcha?" +
        //   new Date().getTime();
        this.showCodeImg = true;
      }
    },
    checkAllInputs() {
      if (this.signUpWay === "phone") {
        this.submitReady =
          this.ruleForm.phone &&
          this.ruleForm.code &&
          this.ruleForm.name &&
          this.ruleForm.password &&
          this.ruleForm.v_password &&
          this.radioChecked
            ? true
            : false;
      } else if (this.signUpWay === "email") {
        this.submitReady =
          this.checkValue(this.ruleForm.email, this.validEmail) &&
          this.ruleForm.code &&
          this.checkValue(this.ruleForm.password, this.validFirstPassword) &&
          this.checkValue(this.ruleForm.v_password, this.validPassword) &&
          this.radioChecked
            ? true
            : false;
      }
    },
    getCodeList() {
      this.$apis.common.getCountryList().then((res) => {
        this.codeList = res.data.data.map((item) => {
          return {
            id: item.id,
            val: "+" + item.country_id,
          };
        });
        (this.selected.id = this.codeList[0].id),
          (this.selected.val = this.codeList[0].val);
      });
    },
    countDown() {
      if (this.minute > 0) {
        this.minute--;
        this.resend = false;
        this.txt.getCode = this.$t("signup.resend") + this.minute + "s";
        setTimeout(() => {
          this.countDown();
        }, 1000);
      } else {
        this.minute = 60;
        this.resend = true;
        this.txt.getCode = this.$t("signup.reget");
      }
    },
    sendEmailCode(handle) {
      const params = {
        user: this.ruleForm.email,
        type: 0,
        emailCaptcha: this.emailCaptcha,
      };
      if (!this.emailCaptcha) {
        return;
      }
      this.$apis.signup
        .sendEmailCode(params.user, params.type, params.emailCaptcha)
        .then((res) => {
          handle(res);
        });
    },
    sendSms() {
      var handleCodeRes = (res) => {
        this.closeModal();
        if (res.data.code === 0) {
          this.$refs.code.reset();
          this.ruleForm.code = "";
          this.emailCaptcha="";
          this.countDown();

          // 显示验证码发送提示
          var info = {
            des: this.$t("signup.codeSent"),
            data:
              this.signUpWay === "email"
                ? this.ruleForm.email
                : this.selected.val + " " + this.ruleForm.phone,
            flag: true,
          };
          this.$refs.code.update(info);
        } else {
          this.handleErrorCode(res.data);
        }
      };

      if (this.signUpWay === "email") {
        this.sendEmailCode(handleCodeRes);
        return false;
      }
      const params = {
        cid: this.selected.id,
        tel: this.ruleForm.phone + "",
        type: 0,
        captcha: this.ruleForm.imgCode + "",
      };

      this.$apis.signup
        .sendSms(params.cid, params.tel, params.type, params.captcha)
        .then((res) => {
          handleCodeRes(res);
        });
    },
    closeErrorModal() {
      this.errorFlag = false;
    },
    emailSignUp(pwd) {
      const params = {
        user: this.ruleForm.email,
        pwd: pwd,
        rePwd: pwd,
        captcha: this.ruleForm.code,
      };
      this.$apis.signup
        .emailSignUp(params.user, params.pwd, params.rePwd, params.captcha)
        .then((res) => {
          var code = res.data.code;
          if (code === 0) {
            // 跳转至redirectUrl
            this.showModal = true;
            this.countDownCounter();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    signUp() {
      if (this.signUpWay === "email") {
        this.$apis.signup.getPublicKey().then((res) => {
          var jsencrypt = new JSEncrypt();
          jsencrypt.setPublicKey(res.data.data.rsa_key);
          var output = jsencrypt.encrypt(
            res.data.data.hash + this.ruleForm.password
          );
          var code = res.data.code;
          if (code === 0) {
            // 获取publickey后
            this.emailSignUp(output);
          } else {
            this.handleErrorCode(res.data);
          }
        });
        return false;
      }
      const params = {
        cid: this.selected.id,
        tel: this.ruleForm.phone + "",
        code: this.ruleForm.code,
        nickName: this.ruleForm.name,
        pwd: this.ruleForm.password,
        repeatPwd: this.ruleForm.v_password,
      };
      this.$apis.signup
        .signUp(
          params.cid,
          params.tel,
          params.code,
          params.nickName,
          params.pwd,
          params.repeatPwd
        )
        .then((res) => {
          var code = res.data.code;
          if (code === 0) {
            // 跳转至redirectUrl
            this.showModal = true;
            this.countDownCounter();
          } else {
            this.handleErrorCode(res.data);
          }
        });
    },
    countDownCounter() {
      if (this.counter > 1) {
        this.counter--;
        setTimeout(() => {
          this.countDownCounter();
        }, 1000);
      } else {
        this.goPrev();
      }
    },
    testRedirectUrl(str) {
      var res =
        str && str.indexOf(this.$siteConfig.domainWithoutPrefix) > -1
          ? str
          : null;
      return res;
    },
    goPrev() {
      this.goLogin();
    },
    selectOption(item) {
      this.selected = item;
    },
    closeModal() {
      this.showCodeImg = false;
    },
    goLogin() {
      var redirectUrl = this.testRedirectUrl(getParams("redirect"));
      var directUrl = redirectUrl
        ? redirectUrl
        : "https:" + this.$siteConfig.domain;

      if (getParams("redirect")) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: directUrl,
          },
        });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    goPrivacy() {
      window.location.href = this.$siteConfig.domain + "/terms";
    },
    // 错误信息提示接口message信息
    handleErrorCode(data) {
      if (data.code == -101) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href,
          },
        });
        return false;
      }

      this.errorMsg = data.message;
      this.errorFlag = true;
    },
  },
  watch: {
    ruleForm: {
      handler: function() {
        this.checkAllInputs();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/scss/common.scss";

.top-container {
  min-width: 1300px;
  max-width: 1920px;
}
.success-tip {
  font-size: 12px;
  color: #999999;
}
.success-link {
  color: #2da2d4;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.success-mask {
  position: fixed;
  z-index: 13;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.success-pop-modal {
  margin-top: 170px;
  margin-left: 50%;
  padding: 40px 20px;
  width: 440px;
  height: 260px;
  background-color: #fff;
  border-radius: 12px;
  text-align: center;
  transform: translateX(-50%);
  overflow: hidden;
}
.success-icon {
  margin-top: -2px;
  margin-right: 5px;
  vertical-align: middle;
}
// .success-btn {
//     display: inline-block;
//     margin-bottom: 10px;
//     width: 170px;
//     height: 40px;
//     line-height: 40px;
//     color: #fff;
//     border-radius: 20px;
//     background-color: #2DA2D4;
//     transition: all .3s;
//     cursor: pointer;
//     &:hover {
//         box-shadow: 0 4px 6px 0 rgba(10,131,186,0.3);
//     }
// }
.success-line {
  margin: 40px 0;
  line-height: 22px;
  font-size: 16px;
  color: #444;
}
.success-pic {
  width: 100%;
  height: 120px;
}

.k-form .k-input-wrapper {
  margin-left: 159px;
}
.contact-container {
  height: 867px;
  background: url("~@assetImages/passport/bg_account.jpg") center center
    no-repeat;
  // background-size: 100% 100%;
  background-size: 1920px 1147px;
  background-position: center;
}
.signup-root {
  position: relative;
  min-width: 1366px;
  max-width: 1920px;
}
.code-info {
  position: absolute;
  top: 100%;
  left: 0;
  padding-top: 4px;
  font-size: 12px;
  color: #999;
  line-height: 1;
  .code-phone {
    color: #2da2d4;
  }
}
.mask {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.tit-border {
  display: inline-block;
  width: 4px;
  height: 20px;
  margin-top: -4px;
  margin-right: 6px;
  border-radius: 2px;
  vertical-align: middle;
  background-color: #2da2d4;
}
.close-icon {
  float: right;
  cursor: pointer;
  transition: transform 0.3s;
  &:hover {
    transform: rotate(90deg);
  }
}
.pop-modal {
  margin-top: 214px;
  margin-left: 50%;
  width: 400px;
  height: 270px;
  background-color: #fff;
  border-radius: 12px;
  transform: translateX(-50%);
  .modal-head {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    color: #444;
  }
}
.modal-form {
  padding: 40px 30px;
}
.login-box {
  position: relative;
  top: 60px;
  margin: 0 auto;
  padding: 40px 80px;
  width: 520px;
  height: 654px;
  background-color: #fff;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}
.login-tit {
  margin-bottom: 40px;
  font-size: 32px;
  text-align: center;
  color: #444;
}
.tip-line {
  font-size: 12px;
  line-height: 18px;
  color: #444;
  .tip-link {
    color: #2da2d4;
    text-decoration: none;
    cursor: pointer;
    &.jp-link {
      margin-right: 3px;
    }
    &.normal-underline {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.login-box-bot {
  margin-top: 40px;
  text-align: center;
  .login-btn {
    display: inline-block;
    margin-bottom: 10px;
    width: 170px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 20px;
    background-color: #ccc;
    pointer-events: none;
    &.allowed {
      background-color: #2da2d4;
      transition: all 0.2s;
      cursor: pointer;
      pointer-events: auto;
      &:hover {
        box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
      }
    }
  }
}
// .phone-input .k-input-input {
//   padding-left: 95px;
// }
.radio-box {
  position: relative;
  display: inline-block;
  margin-top: -2px;
  margin-right: 10px;
  width: 10px;
  height: 10px;
  border: 2px solid #ccc;
  border-radius: 3px;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    border-color: #2da2d4;
  }
  &:after {
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 5px;
    left: 4px;
    position: absolute;
    top: 2px;
    transform: rotate(45deg) scaleY(0);
    width: 4px;
    transition: transform 0.1s ease-in 0.05s;
    transform-origin: center;
  }
  &.checked {
    width: 14px;
    height: 14px;
    border: none;
    background-color: #2da2d4;
    &:after {
      transform: rotate(45deg) scaleY(1);
    }
  }
}
.k-form .k-input-wrapper {
  position: relative;
  margin-bottom: 40px;
}
.code-area {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2;
  width: 85px;
  height: 30px;
  padding-left: 20px;
  line-height: 30px;
  border-right: 1px solid #eee;
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: none;
    color: #2da2d4;
  }
}
.code-tip {
  position: absolute;
  top: 10px;
  right: 0;
  width: 112px;
  text-align: center;
  color: #2da2d4;
  line-height: 30px;
  border-left: 1px solid #eee;
  cursor: pointer;
  &.jp {
    width: 130px;
    font-size: 12px;
  }
  &.modal-code {
    top: 6px;
    right: 6px;
    height: 34px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 17px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
  &.off {
    pointer-events: none;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
$jpBlue: #50bbe5;

.phone-input .k-input-input {
  padding-left: 95px;
}
.confirm-pwd {
  &.jp {
    .k-input-tit {
      font-size: 14px;
    }
  }
}
.login-box {
  &.jp {
    .radio-box {
      border-width: 1px;
    }
    .tip-line .tip-link,
    .code-tip {
      color: $jpBlue;
    }
  }
}
input::-webkit-input-placeholder {
  color: #c0c4cc !important;
}
</style>
